module.exports = __webpack_public_path__ + "static/media/29BDOS11.085729e9.jpg";